module.exports = "/assets/data/bd18f6fedae658a93b9638b3368f095f-OL7.data.json";